import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.review');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-review',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.company.review/view.scss */
:host {
  display: block;
}

:host ::ng-deep .review-answer {
  line-height: 1.65;
  overflow-wrap: anywhere;
}

:host ::ng-deep .review-answer img {
  max-width: 100%;
  height: auto;
}

:host ::ng-deep .review-answer table {
  width: 100%;
  border-collapse: collapse;
}

:host ::ng-deep .review-answer th,
:host ::ng-deep .review-answer td {
  border: 1px solid #e4e4e7;
  padding: 6px 8px;
}`],
})
export class PortalLpsysadminWidgetCompanyReviewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;
    @Input() category: any = 'investment';
    @Input() mode: any = 'request';

    public loading: boolean = true;
    public saving: boolean = false;
    public runningLlmReview: boolean = false;
    public request: any = null;
    public documents: any[] = [];
    public questions: any[] = [];
    public reviewCriteria: any[] = [];
    public llmReviewResult: any = {};
    public assignees: any[] = [];
    public permissions: any = { can_edit: false, can_assign: false, is_super_admin: false };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        if (!this.company || !this.company.id) {
            this.loading = false;
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call('load', { company_id: this.company.id });
        if (code === 200) {
            this.applyResponse(data.data);
        }
        this.loading = false;
        await this.service.render();
    }

    private applyRequest(request: any) {
        this.request = request || null;
        this.documents = this.request?.document_items || [];
        this.questions = this.request?.questions || [];
        this.reviewCriteria = this.request?.llm_review_criteria || [];
        this.llmReviewResult = this.request?.llm_review_result || {};
    }

    private applyResponse(payload: any) {
        const request = payload?.request || payload;
        this.applyRequest(request);
        if (payload?.permissions) this.permissions = payload.permissions;
        if (payload?.assignees) this.assignees = payload.assignees;
    }

    public canEdit(): boolean {
        return !!this.permissions?.can_edit;
    }

    public canAssign(): boolean {
        return !!this.permissions?.can_assign || this.canEdit();
    }

    public isSuperAdmin(): boolean {
        return !!this.permissions?.is_super_admin;
    }

    public assigneeLabel(): string {
        const assignee = this.request?.assignee || {};
        const name = assignee.name || this.request?.assignee_name || '';
        const email = assignee.email || this.request?.assignee_email || '';
        if (name && email) return `${name} (${email})`;
        return name || email || '담당자 미지정';
    }

    private guardEdit(): boolean {
        if (this.canEdit()) return true;
        this.service.alert.error('지정된 내부 담당자 또는 최고관리자만 수정할 수 있습니다.');
        return false;
    }

    private guardSave(): boolean {
        if (this.canEdit() || this.canAssign()) return true;
        this.service.alert.error('담당자 지정 또는 수정 권한이 없습니다.');
        return false;
    }

    public payload() {
        return {
            title: this.request?.title || '',
            message: this.request?.message || '',
            recipient_email: this.request?.recipient_email || '',
            assignee_user_id: this.request?.assignee_user_id || '',
            review_note: this.request?.review_note || '',
            document_items: this.documents,
            questions: this.questions,
            llm_review_criteria: this.reviewCriteria
        };
    }

    public async save(showAlert: boolean = true) {
        if (!this.guardSave()) return;
        if (!this.company?.id || !this.request) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.applyResponse(data.data);
            if (showAlert) this.service.alert.success('저장되었습니다.');
        } else {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
        }
        await this.service.render();
    }

    public async saveAssignee() {
        if (!this.canAssign()) {
            this.service.alert.error('담당자를 지정할 권한이 없습니다.');
            return;
        }
        await this.save(true);
    }

    public async sendRequest() {
        if (!this.guardEdit()) return;
        if (!this.request?.recipient_email) {
            this.service.alert.error('담당자 이메일을 입력하세요.');
            return;
        }
        const confirmed = await this.service.alert.show({
            title: '자료 요청 발송',
            message: `${this.request.recipient_email}로 자료 요청 메일을 발송하시겠습니까?`,
            cancel: '취소',
            action: '발송',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_request', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.applyResponse(data.data);
            this.service.alert.success('요청 메일을 발송했습니다.');
        } else {
            this.service.alert.error(data?.message || '메일 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public addDocument() {
        if (!this.guardEdit()) return;
        this.documents.push({
            id: 'doc_' + Date.now(),
            title: '',
            description: '',
            required: true,
            file_url: '',
            file_name: ''
        });
        this.service.render();
    }

    public removeDocument(index: number) {
        if (!this.guardEdit()) return;
        this.documents.splice(index, 1);
        this.service.render();
    }

    public addQuestion() {
        if (!this.guardEdit()) return;
        this.questions.push({
            id: 'q_' + Date.now(),
            question: '',
            required: true,
            answer: ''
        });
        this.service.render();
    }

    public removeQuestion(index: number) {
        if (!this.guardEdit()) return;
        this.questions.splice(index, 1);
        this.service.render();
    }

    public async copyLink() {
        const link = this.requestLink();
        if (!link) return;
        try {
            await navigator.clipboard.writeText(link);
            this.service.alert.success('링크를 복사했습니다.');
        } catch (e) {
            this.service.alert.error('링크 복사에 실패했습니다.');
        }
    }

    public requestLink(): string {
        if (!this.request) return '';
        if (this.request.link) return this.request.link;
        if (this.request.token) return `${location.origin}/company-review/${this.request.token}`;
        return '';
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '작성중', requested: '요청 발송', submitted: '기업 제출', rerequested: '재요청 발송' };
        return map[status] || status || '작성중';
    }

    public statusClass(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-700',
            requested: 'bg-blue-50 text-blue-700',
            submitted: 'bg-emerald-50 text-emerald-700',
            rerequested: 'bg-amber-50 text-amber-700'
        };
        return map[status] || 'bg-zinc-100 text-zinc-700';
    }

    public selectedRerequestCount(): number {
        return [...this.documents, ...this.questions].filter((item: any) => item.rerequest_selected).length;
    }

    public pendingRerequestCount(): number {
        return [...this.documents, ...this.questions].filter((item: any) => item.rerequest_status === 'pending').length;
    }

    public hasSelectedRerequest(): boolean {
        return this.selectedRerequestCount() > 0;
    }

    public isPending(item: any): boolean {
        return item?.rerequest_status === 'pending';
    }

    public historyCount(item: any, key: string): number {
        const list = item?.[key];
        return Array.isArray(list) ? list.length : 0;
    }

    public historyList(item: any, key: string): any[] {
        const list = item?.[key];
        return Array.isArray(list) ? list : [];
    }

    public itemRerequestLabel(item: any): string {
        if (this.isPending(item)) return '보완 대기';
        if (item?.rerequest_status === 'resolved') return '보완 완료';
        return '';
    }

    public itemRerequestClass(item: any): string {
        if (this.isPending(item)) return 'bg-amber-50 text-amber-700';
        if (item?.rerequest_status === 'resolved') return 'bg-emerald-50 text-emerald-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public hasAnswer(value: any): boolean {
        return this.answerText(value).length > 0;
    }

    public answerText(value: any): string {
        const div = document.createElement('div');
        div.innerHTML = String(value || '');
        return (div.textContent || div.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    public async sendRerequest() {
        if (!this.guardEdit()) return;
        if (!this.request?.recipient_email) {
            this.service.alert.error('담당자 이메일을 입력하세요.');
            return;
        }
        if (!this.hasSelectedRerequest()) {
            this.service.alert.error('재요청할 파일이나 답변을 선택하세요.');
            return;
        }
        const missingReason = [...this.documents, ...this.questions].find((item: any) => item.rerequest_selected && !String(item.rerequest_reason || '').trim());
        if (missingReason) {
            this.service.alert.error('선택한 항목마다 재요청 사유를 입력하세요.');
            return;
        }
        const confirmed = await this.service.alert.show({
            title: '재요청 발송',
            message: `선택한 ${this.selectedRerequestCount()}개 항목에 대한 보완 요청 메일을 발송하시겠습니까?`,
            cancel: '취소',
            action: '발송',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_rerequest', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.applyResponse(data.data);
            this.service.alert.success('재요청 메일을 발송했습니다.');
        } else {
            this.service.alert.error(data?.message || '재요청 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public addCriterion() {
        if (!this.guardEdit()) return;
        this.reviewCriteria.push({
            id: 'criterion_' + Date.now(),
            label: '',
            max_score: 10,
            description: ''
        });
        this.service.render();
    }

    public removeCriterion(index: number) {
        if (!this.guardEdit()) return;
        this.reviewCriteria.splice(index, 1);
        this.service.render();
    }

    public criteriaTotal(): number {
        return (this.reviewCriteria || []).reduce((sum: number, item: any) => sum + this.numberValue(item.max_score), 0);
    }

    public numberValue(value: any): number {
        if (typeof value === 'string') {
            const match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
            if (!match) return 0;
            value = match[0];
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    public hasSubmittedMaterials(): boolean {
        return (this.documents || []).some((doc: any) => !!doc.file_url)
            || (this.questions || []).some((q: any) => this.hasAnswer(q.answer));
    }

    private fieldValue(source: any, keys: string[], fallback: any = ''): any {
        if (!source || typeof source !== 'object') return fallback;
        for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null && source[key] !== '') {
                return source[key];
            }
        }
        return fallback;
    }

    private mapScore(scores: any, criterion: any): any {
        if (!scores || typeof scores !== 'object') return 0;
        const keys = [criterion.id, criterion.label, String(criterion.id || '').toLowerCase(), String(criterion.label || '').toLowerCase()];
        for (const key of keys) {
            if (key && Object.prototype.hasOwnProperty.call(scores, key)) return scores[key];
        }
        return 0;
    }

    private normalizeResultItem(item: any, fallback: any = {}): any {
        const maxScore = this.numberValue(this.fieldValue(item, ['max_score', 'maxScore', 'maximum_score', 'max'], this.fieldValue(fallback, ['max_score', 'maxScore'], 0)));
        return {
            id: this.fieldValue(item, ['id', 'key'], fallback.id || ''),
            label: this.fieldValue(item, ['label', 'name', 'title', 'criterion', '항목'], fallback.label || ''),
            max_score: maxScore,
            score: Math.max(0, Math.min(maxScore || 999999, this.numberValue(this.fieldValue(item, ['score', 'point', 'points', 'value', '점수'], 0)))),
            comment: this.fieldValue(item, ['comment', 'opinion', 'reason', 'feedback', 'analysis', '평가의견', '의견'], ''),
            evidence: Array.isArray(item?.evidence) ? item.evidence : []
        };
    }

    public resultItems(): any[] {
        const items = this.llmReviewResult?.items;
        if (Array.isArray(items) && items.length > 0) {
            return items.map((item: any, index: number) => this.normalizeResultItem(item, this.reviewCriteria[index] || {}));
        }
        const scoreMap = this.llmReviewResult?.scores || this.llmReviewResult?.criteria_scores || this.llmReviewResult?.criterion_scores;
        if (scoreMap && typeof scoreMap === 'object') {
            return (this.reviewCriteria || []).map((criterion: any) => this.normalizeResultItem({
                id: criterion.id,
                label: criterion.label,
                max_score: criterion.max_score,
                score: this.mapScore(scoreMap, criterion)
            }, criterion));
        }
        return [];
    }

    public reviewScore(): number {
        const direct = this.numberValue(this.fieldValue(this.llmReviewResult, ['total_score', 'score', 'score_total', 'totalScore', 'total', '점수', '총점'], 0));
        if (direct > 0) return direct;
        return this.resultItems().reduce((sum: number, item: any) => sum + this.numberValue(item.score), 0);
    }

    public reviewMaxScore(): number {
        const stored = this.numberValue(this.fieldValue(this.llmReviewResult, ['max_score', 'maxScore', 'maximum_score', 'maximum', '만점'], 0));
        return stored > 0 ? stored : this.criteriaTotal();
    }

    public hasReviewScore(): boolean {
        return this.reviewMaxScore() > 0 && (!!this.llmReviewResult?.generated_at || this.resultItems().length > 0 || this.reviewScore() > 0);
    }

    public resultList(key: string): string[] {
        const list = this.llmReviewResult?.[key];
        return Array.isArray(list) ? list : [];
    }

    public sourceDocuments(): any[] {
        const list = this.llmReviewResult?.source_documents;
        return Array.isArray(list) ? list : [];
    }

    public sourceWarnings(): string[] {
        const list = this.llmReviewResult?.source_warnings;
        return Array.isArray(list) ? list : [];
    }

    public scorePercent(score: any, maxScore: any): number {
        const max = this.numberValue(maxScore);
        if (max <= 0) return 0;
        return Math.max(0, Math.min(100, Math.round((this.numberValue(score) / max) * 100)));
    }

    public async saveCriteria() {
        if (!this.guardEdit()) return;
        if (!this.reviewCriteria.length) {
            this.service.alert.error('평가 항목을 1개 이상 입력하세요.');
            return;
        }
        await this.save(true);
    }

    public async runLlmReview() {
        if (!this.guardEdit()) return;
        if (!this.reviewCriteria.length) {
            this.service.alert.error('평가 항목을 1개 이상 입력하세요.');
            return;
        }
        const invalid = this.reviewCriteria.find((item: any) => !String(item.label || '').trim() || this.numberValue(item.max_score) <= 0);
        if (invalid) {
            this.service.alert.error('평가 항목명과 배점을 입력하세요.');
            return;
        }
        if (!this.hasSubmittedMaterials()) {
            this.service.alert.error('LLM 검토에 사용할 제출 서류나 답변이 없습니다.');
            return;
        }
        const confirmed = await this.service.alert.show({
            title: 'LLM 검토 실행',
            message: `현재 평가 항목 총 ${this.criteriaTotal()}점 기준으로 제출 자료를 검토하시겠습니까?`,
            cancel: '취소',
            action: '실행',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;

        this.runningLlmReview = true;
        await this.service.render();
        const { code, data } = await wiz.call('run_llm_review', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.runningLlmReview = false;
        if (code === 200) {
            this.applyResponse(data.data);
            this.service.alert.success('LLM 검토가 완료되었습니다.');
        } else {
            this.service.alert.error(data?.message || 'LLM 검토에 실패했습니다.');
        }
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetCompanyReviewComponent;